<template>
<div class="runnability">
  <Vueheader :addActive='addActive'></Vueheader>
  <div class="content">
    <div class="left">
      <div class="allLedger">
        <div class="ledger active" @click="statistics"><span class="iconfont icon-ren111">总推荐人</span></div>
        <div class="ledger" style="margin: 0 3.5%;" @click="statistics('mount')"><span class="iconfont icon-renqun">总上岗人数</span></div>
        <div class="ledger" @click="statistics('duration')"><span class="iconfont icon-shijian00">总服务时长</span></div>
      </div>
      <vue-highcharts :options="options" ref="lineCharts"></vue-highcharts>
    </div>
    <div class="right">
      <div class="rightcenter" >
        <img src="static/img/sharebg.png" class="sharebg">
        <div class="rightTxt">
          <img src="static/img/logo.png" class="logo">
          <img src="static/img/logotxt.png" class="logotxt">
          <p class="logotext">在家做客服，在家赚钱</p>
          <p class="wenben">从零开始，邀请您进入在家赚钱的淘金云客服平台</p>
          <img :src="icon" class="QRcode">
          <p class="discern">长按识别二维码</p>
        </div>
      </div>
    </div>
  </div>
</div>   
</template>

<script type="text/javascript">
  import VueHighcharts from 'vue2-highcharts'
  import Vueheader from '../components/header'
	export default {
    name: 'runnability',
		data(){
			return{
        'addActive': 1,
        'xAxis': '日期（年/月/日）',
        'yTitle': '数量（人）',
        'botTxt': '每日推荐人',
        'options': {},
        'agentId': this.$route.query.agentId,
        'yList': [],
        'xList': [],
        'referrer': '',
        'mount': '',
        'time': '',
        'icon': ''
			}
		},
		mounted() {
      this.statistics()
      this.searchAgent()
      this.optionsObject()
    },
    components: {
      VueHighcharts,
      Vueheader
    },
		methods: {
      statistics: function(txt) {
        $('.ledger').removeClass('active')
        if(txt == 'mount') {
          $('.ledger').eq(1).addClass('active')
        }else if(txt == 'duration') {
          $('.ledger').eq(2).addClass('active')
        }else {
          $('.ledger').eq(0).addClass('active')
        }
        var data = {
          'agentId': this.agentId
        }
        this.$http.post(API_ROOT.system + "/agency/statistics",data).then(response=> {
          var result = response.data
          this.yList = []
          this.xList = []
          this.referrer = ''
          this.mount = ''
          this.time = ''
          if(result.success) {
            var obj = {}
            var data = result.data.list
            for(var i = 0 ;i<data.length ; i++) {
              this.xList.push(data[i].createDay)
              this.referrer = this.referrer+data[i].recommenders
              this.mount = this.mount+data[i].onJobs
              this.time = this.time+data[i].workHour
            }
            this.judge(txt,data)
            this.load()
            this.optionsObject()
          }else {
            this.$message({
              message: result.msg,
              type: 'error',
              center: true,
              duration: 2000
            })
          }
        },response=> {
          this.$message({
            message: '网络繁忙，请稍后重试！',
            type: 'error',
            center: true,
            duration: 2000
          })
        })
      },
      //查询代理人
			searchAgent() {
				var data = {
					page: 1,
					pageSize:1
				}
				this.$http.post(API_ROOT.system + "/agency/search",data).then(response=> {
					var result = response.data
					if(result.success) {
						this.icon = result.data.list[0].recommendLink
					}else {
						this.$message({
              message: result.msg,
              type: 'error',
              center: true,
              duration: 2000
            })
					}
				},response=> {
					this.$message({
            message: '网络繁忙，请稍后重试！',
            type: 'error',
            center: true,
            duration: 2000
          })
				})
			},
      //变化曲线图信息
      judge:function(txt,data) {
        if(txt == 'mount') {
          this.yTitle =  "数量（人）"
          this.botTxt = '每日总上岗人'
          for(var i = 0 ;i<data.length ; i++) {
            this.yList.push(data[i].onJobs)
          }
        }else if (txt == 'duration'){
          this.yTitle =  "时间（H）"
          this.botTxt = '每日总服务时长' 
          for(var i = 0 ;i<data.length ; i++) {
            this.yList.push(data[i].workHour)
          }
        }else {
          this.yTitle =  "数量（人）"
          this.botTxt =  '每日推荐人' 
          for(var i = 0 ;i<data.length ; i++) {
            this.yList.push(data[i].recommenders)
          }
        }
      },
      //渲染曲线图数据
      optionsObject: function() {
        this.options = {
          asyncData: {
            name: this.botTxt,
            marker: {
              symbol: ''
            },
            data: this.yList
          },
          chart: {
              type: 'spline'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            xAxis: {
              title: {
                text: this.xAxis
              },
              categories: this.xList
            },
            yAxis: {
              title: {
                text: this.yTitle
              },
              min: 0,
              allowDecimals: false,
              labels: {
                formatter: function () {
                  return this.value ;
                }
              }
            },
            tooltip: {
              crosshairs: true,
              shared: true
            },
            credits: {
              enabled: false
            },
            plotOptions: {
              spline: {
                marker: {
                  radius: 4,
                  lineColor: '#666666',
                  lineWidth: 1
                }
              }
            },
            series: []
        }
      },
      //加载曲线图
      load: function() {
        let lineCharts = this.$refs.lineCharts;
        lineCharts.delegateMethod('showLoading', 'Loading...');
        lineCharts.removeSeries(this.options.asyncData);
        setTimeout(() => {
          $(".highcharts-legend").remove()
          lineCharts.addSeries(this.options.asyncData);
          lineCharts.hideLoading();
        }, 0)
      }
    }
	}
</script>




// WEBPACK FOOTER //
// runnability.vue?0dbd45d1